import React from "react";

import TaskDetailFeature from "../features/myTask/components/TaskDetail";

function MyTask(props) {
  return <TaskDetailFeature {...props} />;
}

export default MyTask;
